import type { AxiosError, AxiosInstance } from 'axios';

import modalStatusService from '~/services/modalStatus';

export const EMAIL_NOT_VERIFIED_CODE = 'EMAIL_NOT_VERIFIED';

interface EmailNotVerifiedPayload {
  statusCode: number;
  error: string;
  code: typeof EMAIL_NOT_VERIFIED_CODE;
  message: string;
  action: {
    type: 'resend-verification';
    endpoint: string;
    label: string;
  };
}

export function isEmailNotVerifiedError(error: AxiosError): boolean {
  if (error.response?.status !== 403) return false;
  const data = error.response.data as Partial<EmailNotVerifiedPayload> | undefined;
  return data?.code === EMAIL_NOT_VERIFIED_CODE;
}

export function showEmailNotVerifiedModal(
  error: AxiosError,
  api: AxiosInstance,
): void {
  const data = error.response?.data as EmailNotVerifiedPayload | undefined;
  const description =
    data?.message ??
    'Você precisa confirmar seu email para realizar esta ação. Verifique sua caixa de entrada.';
  const primaryLabel = data?.action?.label ?? 'Reenviar email de confirmação';

  modalStatusService.show({
    type: 'alert',
    title: 'Confirme seu email',
    description,
    showFirstButton: true,
    textFirstButton: primaryLabel,
    showSecondButton: true,
    textSecondButton: 'Agora não',
    onClickFirstButton: async () => {
      try {
        await api.post('/v1/auth/resend-verification');
        modalStatusService.show({
          type: 'success',
          title: 'Email reenviado',
          description:
            'Enviamos um novo link para sua caixa de entrada. Confirme seu email e tente novamente.',
          showFirstButton: true,
          textFirstButton: 'Entendi',
          onClickFirstButton: () => modalStatusService.hide(),
          handleCloseModal: () => modalStatusService.hide(),
        });
      } catch {
        modalStatusService.show({
          type: 'error',
          title: 'Não foi possível reenviar',
          description:
            'Tente novamente em alguns instantes. Se o problema persistir, fale com o suporte.',
          showFirstButton: true,
          textFirstButton: 'Ok',
          onClickFirstButton: () => modalStatusService.hide(),
          handleCloseModal: () => modalStatusService.hide(),
        });
      }
    },
    onClickSecondButton: () => modalStatusService.hide(),
    handleCloseModal: () => modalStatusService.hide(),
  });
}
